import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import {
  Client,
  GetTarifsPrevoyanceGPARequest,
  GetTarifsPrevoyanceGPAResponse,
  PrevoyanceGPA
} from '../MIF.Subscription.Parrot';

@Injectable({
  providedIn: 'root'
})
export class WsPrevoyanceGPAService {
  constructor(private webApi: Client) {}

  public async getTarifsPrevoyanceGPA(
    age: number,
    x2x3Model: boolean,
    mntCapital: number,
    nbAnnees: number = 20
  ): Promise<any> {
    let prevoyanceGPA = new PrevoyanceGPA({
      age,
      option: x2x3Model ? 2 : 1,
      mntCapital,
      nbAnnees
    });

    const request = new GetTarifsPrevoyanceGPARequest({
      prevoyanceGPA
    });

    return this.webApi
      .getTarifsPrevoyanceGPA(request)
      .pipe(
        map((response: GetTarifsPrevoyanceGPAResponse) => {
          return response;
        })
      )
      .toPromise();
  }
}
